var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningCardBadgeLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 66,
    viewBox: "0 0 58 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2813_30479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9923 5.58773C28.615 5.22447 29.385 5.22447 30.0077 5.58773L51.7949 18.2969C52.5189 18.7193 52.9028 19.5483 52.7565 20.3736L48.1762 46.2119C48.0865 46.7177 47.8057 47.1697 47.3918 47.474L30.1849 60.1285C29.48 60.6469 28.52 60.6469 27.8151 60.1285L10.6082 47.474C10.1943 47.1697 9.91347 46.7177 9.82381 46.2119L5.24351 20.3736C5.09721 19.5483 5.48106 18.7193 6.20507 18.2969L27.9923 5.58773Z",
    fill: "#FFCF61"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0546 16.1375L31.2674 3.42828C29.8663 2.61095 28.1337 2.61095 26.7326 3.42828L4.94539 16.1375C3.31637 17.0877 2.45271 18.953 2.78189 20.8099L7.36218 46.6483C7.56393 47.7864 8.19588 48.8032 9.12703 49.488L26.3339 62.1425C27.9199 63.3089 30.0801 63.3089 31.6661 62.1425L48.873 49.488C49.8041 48.8032 50.4361 47.7864 50.6378 46.6483L55.2181 20.8099C55.5473 18.953 54.6836 17.0877 53.0546 16.1375Z",
    stroke: "#ECB22E",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2813_30479",
    x: -2.78711,
    y: -5.68469,
    width: 60.5742,
    height: 71.2019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2813_30479"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningCardBadgeLg);
export default __webpack_public_path__ + "static/media/LearningCardBadgeLg.d41f043dca66bc3841ae640bafaf2330.svg";
export { ForwardRef as ReactComponent };